module.exports = __webpack_public_path__ + "img/SEJ enventos_logo recrea.8a690e6c.svg";